import React from 'react'
import injectSheet from 'react-jss'
import styles from './current-table.styles'
import { Table, HeadCell } from 'pobble-components/dist/table'
import CurrentEntry from './current-entry/current-entry.container'
import {
  BulkActionProvider,
  SelectAllButton
} from 'pobble-components/dist/bulk-action'
import BulkAction from './bulk-action/bulk-action.container'

const CurrentTable = ({ classes, invitations }) => (
  <BulkActionProvider entities={invitations}>
    <Table>
      <thead>
        <tr>
          <HeadCell className={classes.allCell}>
            <SelectAllButton />
          </HeadCell>
          <HeadCell className={classes.invitedCell}>Invited on</HeadCell>
          <HeadCell className={classes.fromCell}>Invited by</HeadCell>
          <HeadCell className={classes.titleCell}>School</HeadCell>
          <HeadCell className={classes.titleCell}>Title</HeadCell>
          <HeadCell className={classes.center}>Conclusion</HeadCell>
          <HeadCell className={classes.right}>
            <BulkAction />
          </HeadCell>
          <HeadCell />
        </tr>
      </thead>
      <tbody>
        {invitations.map((invitation, index) => (
          <CurrentEntry key={invitation.id} id={invitation.id} index={index} />
        ))}
      </tbody>
    </Table>
  </BulkActionProvider>
)

export default injectSheet(styles)(CurrentTable)
